import kotlinx.browser.*
import org.w3c.dom.*
import kotlin.math.*
import kotlin.random.Random

enum class State { START, PLAYING, GAMEOVER }
data class Bullet(var x: Double, var y: Double, val vx: Double, val vy: Double)
data class Enemy(var x: Double, var y: Double, var hp: Int = 1, var isDead: Boolean = false)
data class Coin(var x: Double, var y: Double, val value: Int)

// Доступ к Telegram WebApp API
val tg = window.asDynamic().Telegram.WebApp

class Game(val canvas: HTMLCanvasElement) {
    val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
    var gameState = State.START
    var score = 0
    var crocoinWallet = 0
    var hp = 100

    // Ресурсы
    val droidImg = Image().apply { src = "Droyd.png" }
    val bulletImg = Image().apply { src = "pul.png" }
    val zombieImg = Image().apply { src = "zombi.png" }
    val coinImg = Image().apply { src = "biit.png" }

    var playerX = 400.0; var playerY = 400.0
    val bullets = mutableListOf<Bullet>()
    val enemies = mutableListOf<Enemy>()
    val coins = mutableListOf<Coin>()
    val keys = mutableSetOf<String>()

    private var lastShotTime = 0.0
    private var lastSpawnTime = 0.0

    fun start() {
        // Загрузка баланса из облака Telegram (Бесплатная БД)
        tg.CloudStorage.getItem("crocoins") { err: Any?, result: String? ->
            if (result != null && result != "") {
                crocoinWallet = result.toInt()
            }
        }

        window.onkeydown = { e -> 
            if (gameState == State.START) gameState = State.PLAYING
            if (gameState == State.GAMEOVER && e.code == "KeyR") restart()
            keys.add(e.code) 
        }
        window.onkeyup = { e -> keys.remove(e.code) }
        
        canvas.onclick = { 
            if (gameState == State.START) gameState = State.PLAYING
            if (gameState == State.GAMEOVER) restart()
        }

        window.requestAnimationFrame(::gameLoop)
    }

    fun restart() {
        score = 0; hp = 100; playerX = 400.0; playerY = 400.0
        enemies.clear(); bullets.clear(); coins.clear()
        gameState = State.PLAYING
    }

    fun saveToCloud() {
        // Сохраняем результат навсегда в аккаунт игрока в Телеграм
        tg.CloudStorage.setItem("crocoins", crocoinWallet.toString())
    }

    fun update() {
        if (gameState != State.PLAYING) return

        if ("KeyW" in keys || "ArrowUp" in keys) playerY -= 7.0
        if ("KeyS" in keys || "ArrowDown" in keys) playerY += 7.0
        if ("KeyA" in keys || "ArrowLeft" in keys) playerX -= 7.0
        if ("KeyD" in keys || "ArrowRight" in keys) playerX += 7.0

        val now = window.performance.now()
        if (now - lastShotTime > 300) {
            bullets.add(Bullet(playerX + 30, playerY, 0.0, -10.0))
            lastShotTime = now
        }

        if (now - lastSpawnTime > 1500) {
            enemies.add(Enemy(Random.nextDouble(50.0, 850.0), -50.0))
            lastSpawnTime = now
        }

        bullets.forEach { it.y += it.vy }
        enemies.forEach { en ->
            val angle = atan2(playerY - en.y, playerX - en.x)
            en.x += cos(angle) * 2.5; en.y += sin(angle) * 2.5
            
            bullets.forEach { b ->
                if (abs(b.x - en.x) < 50 && abs(b.y - en.y) < 50) {
                    en.isDead = true; score += 10
                    coins.add(Coin(en.x, en.y, 5))
                }
            }
            if (abs(playerX - en.x) < 40 && abs(playerY - en.y) < 40) {
                hp -= 10; en.isDead = true
            }
        }
        
        coins.removeAll { c ->
            val dist = sqrt((playerX - c.x).pow(2) + (playerY - c.y).pow(2))
            if (dist < 60) { 
                crocoinWallet += c.value
                saveToCloud() 
                true 
            } else false
        }

        enemies.removeAll { it.isDead || it.y > 950 }
        bullets.removeAll { it.y < -50 }
        if (hp <= 0) {
            gameState = State.GAMEOVER
            saveToCloud()
        }
    }

    fun draw() {
        ctx.clearRect(0.0, 0.0, 900.0, 900.0)
        
        if (gameState == State.START) {
            ctx.fillStyle = "white"; ctx.font = "40px Arial"
            ctx.asDynamic().textAlign = "center"
            ctx.fillText("TAP OR ENTER TO START", 450.0, 450.0)
            return
        }

        ctx.drawImage(droidImg, playerX, playerY, 80.0, 80.0)
        bullets.forEach { ctx.drawImage(bulletImg, it.x, it.y, 20.0, 20.0) }
        enemies.forEach { ctx.drawImage(zombieImg, it.x, it.y, 60.0, 60.0) }
        coins.forEach { ctx.drawImage(coinImg, it.x, it.y, 40.0, 40.0) }

        ctx.fillStyle = "yellow"; ctx.font = "24px Arial"
        ctx.asDynamic().textAlign = "left"
        ctx.fillText("SCORE: $score  CROCOINS: $crocoinWallet  HP: $hp%", 20.0, 40.0)
        
        if (gameState == State.GAMEOVER) {
            ctx.fillStyle = "red"; ctx.font = "60px Arial"
            ctx.asDynamic().textAlign = "center"
            ctx.fillText("GAME OVER", 450.0, 450.0)
        }
    }

    fun gameLoop(time: Double) {
        update()
        draw()
        window.requestAnimationFrame(::gameLoop)
    }
}

fun main() {
    window.onload = {
        tg.ready()
        tg.expand()
        val canvas = document.getElementById("gameCanvas") as HTMLCanvasElement
        Game(canvas).start()
    }
}